import { get, post } from '@api/request';

export async function fetchCasesUpdateConfig(
  { litigationService },
  authenticationToken,
) {
  const url = `${litigationService}/litigation/massupdate/config`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const fetchSearchConfig = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/config/search`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchCodes = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/config/searchcodes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchResultsConfig = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/config/searchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const search = async (
  { litigationService },
  authenticationToken,
  { pageSize, page, sortField, sortDirection, filterModel, payload },
) => {
  let url = `${litigationService}/litigation/case/search?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchStandalone = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  let url = `${litigationService}/litigation/case/search`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchCodefileCaseStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Case Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileJuryType = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Jury Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileTrialType = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Trial Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileAppraiserType = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Appraiser Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileDiscoveryStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Discovery Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileMotionStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Motion Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileOfferStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Offer Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};
